import util from './_util';

const {request} = util;

export default {
    getuserinfo() {
        return request.get('/SysAdmin/GetAdminInfo')
    }
}  